/**
 * Message of a failed RTK Query call.
 *
 * `baseQueryWithReauth` (redux/apiSlice.ts) rewrites every error body to `{ message }`, taken
 * from FastAPI's `detail`. `detail` is still read as a fallback for callers that bypass it.
 */
export const getApiErrorMessage = (error: unknown, fallback = "Something went wrong."): string => {
  const data = (error as { data?: { message?: unknown; detail?: unknown } } | undefined)?.data;
  const message = data?.message ?? data?.detail;
  if (Array.isArray(message)) return message.join(", ") || fallback;
  return typeof message === "string" && message.trim() ? message : fallback;
};
